import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/receipt/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Receipt Management',
    meta: {
      title: 'modules.receipt.receiptManagement.title',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.receipt,
      icon: 'receipt',
    },
    children: [
      {
        path: MODULE_PATH + 'upload/sales/rental/new',
        component: load('application/receipt/components/RentalSalesReceiptUploadArea'),
        name: 'Rental Sales Receipt Upload',
        meta: {
          title: 'modules.receipt.receiptManagement.rentalSaleReceiptUpload.title',
          menuItem: true,
          sorting: 1001,
        },
      },
      {
        path: MODULE_PATH + 'general/list',
        component: load('application/receipt/components/GeneralReceiptList'),
        name: 'General Receipt List',
        meta: {
          title: 'modules.receipt.receiptManagement.generalReceipt.title',
          menuItem: config.toggles.modules.generalReceipt,
          sorting: 1001,
        },
      },
      {
        path: MODULE_PATH + 'general/new',
        component: load('application/receipt/components/GeneralReceiptArea'),
        name: 'General Receipt New',
        meta: {
          title: 'modules.receipt.receiptManagement.generalReceipt.title',
          menuItem: false,
          sorting: 1001,
        },
      },
      {
        path: MODULE_PATH + 'general/view/[:receiptID]',
        component: load('application/receipt/components/GeneralReceiptArea'),
        name: 'General Receipt View',
        props: true,
        meta: {
          title: 'modules.receipt.receiptManagement.generalReceipt.title',
          menuItem: false,
          sorting: 1001,
        },
      },
    ],
  },
]
